import React, { createContext, useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom"
import axiosVeteriner from "../../axios/axiosVeteriner";
import axiosChat from "../../axios/axiosChat";
const { CHAT_SOCKET_HOST } = require("../../config");

const ChatSocketContext = createContext();

const ChatSocketContextProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [socket, setSocket] = useState(null);

  const [contacts, setContacts] = useState([]);
  const [chats, setChats] = useState([]);
  const [chatsContacts, setChatContacts] = useState([]);

  const [filteredContacts, setFilteredContacts] = useState([])
  const [filteredChats, setFilteredChats] = useState([])

  const [fetchingMessages, setFetchingMessages] = useState(false)


  const [initialChatCheck, setInitialChatCheck] = useState(false)

  let scrollRef;

  const connectToServer = () => {
    let token = localStorage.natusToken;
    console.log('Trying to connect to chat socket servers...');
    setSocket(new WebSocket(CHAT_SOCKET_HOST + '/' + token));
    console.log(CHAT_SOCKET_HOST + '/' + token);
  };

  const disConnect = () => {
    socket.close();
  }

  useEffect(() => {
    console.log(ReactDOM.findDOMNode(scrollRef))
  }, [])

  const searchContacts = (query) => {
    if (query.length) {
      let _filteredContacts = contacts.filter(contact => {
        return contact.displayName
          .toLowerCase()
          .includes(query.toLowerCase())
      })
      let _filteredChats = chatsContacts.filter(chat => {
        return chat.displayName
          .toLowerCase()
          .includes(query.toLowerCase())
      })
      setFilteredChats(_filteredChats)
      setFilteredContacts(_filteredContacts)
    } else {
      return
    }
  }

  const markSeenAllMessages = (uid) => {
    const _chat = Object.entries(chats).find(([key, value]) => key == uid);
    const newDateTime = new Date().getTime()
    if (!_chat) {
      return
    }
    const [_uid, chat] = _chat;

    const _chts = { ...chats }
    _chts[uid].lastRead = newDateTime
    setChats(_chts)

    const payload = JSON.stringify({
      event: 'lastReadUpdate',
      data: {
        roomId: chat.roomId,
        lastRead: newDateTime,
      }
    })

    socket.send(payload)

  }

  const sendMessage = async (id, isPinned, text) => {
    if (text.length > 0) {
      let roomId
      if (chats.hasOwnProperty(id)) {
        /** ODA VAR & DAHA ÖNCE KONUŞMAYA BAŞLANMIŞ */
        roomId = chats[id].roomId;
      }
      else {
        /** ODA YOK İLK DEFA KONUŞULACAK */
        await axiosChat
          .post("/chat/createRoom", {
            metaId: 0,
            userId: id,
            userType: "VETERINER",
            roomType: "CLINIC",
          })
          .then((response) => {
            const room = response.data;
            roomId = response.data.id;
            let _chats = { ...chats }

            let targetUser = room.users.find(usr => usr.userId !== userId);
            let meUser = room.users.find(usr => usr.userId == userId);

            let messages = room.messages.map(msg => ({
              id: msg.id,
              textContent: msg.message,
              time: new Date(msg.date).toString(),
              isSent: msg.userId === userId,
              isSeen: false // TODO
            }));

            _chats[targetUser.userId] = {
              isPinned: false,
              roomId: room.id,
              initialMessagesFetched: true,
              messagesFinished: false,
              // Just For ME
              lastRead: meUser.lastRead,
              msg: messages
            }

            const chatsContactsArray = contacts.filter(contact => {
              if (_chats[contact.uid]) return _chats[contact.uid]
              else return null
            })
            setChats(_chats);
            setChatContacts(chatsContactsArray)

          })
      }

      const payload = JSON.stringify({
        event: 'message',
        data: {
          roomId: roomId,
          message: text,
        }
      })
      socket.send(payload);

    } else {
      return
    }
  }

  const fetchMessages = (uid, initialFetch) => {
    if (fetchingMessages) {
      return;
    }

    const _chat = Object.entries(chats).find(([key, value]) => key == uid);
    if (!_chat) {
      return
    }
    const [_uid, chat] = _chat;

    if (chat.msg.length < 1) {
      return
    }
    let beforeId = chat.msg[0].id;

    if (chat.messagesFinished) {
      return
    }

    if (initialFetch) {
      if (chat.initialMessagesFetched) {
        return
      }
      chat.initialMessagesFetched = true;
    }

    setFetchingMessages(true);

    axiosChat
      .get(`/chat/roomMessages?roomId=${chat.roomId}&beforeId=${beforeId}`)
      .then((response) => {
        if (response.data.length == 0) {
          chat.messagesFinished = true;
          setFetchingMessages(false);
          return;
        }
        let _cht = { ...chat };
        response.data.forEach((msg) => {
          _cht.msg = [
            {
              id: msg.id,
              textContent: msg.message,
              time: new Date(msg.date).toString(),
              isSent: msg.userId === userId,
              isSeen: false, // TODO
            },
            ..._cht.msg,
          ];
        });
        let _chats = { ...chats };
        _chats[uid] = _cht;

        setChats(_chats);
        setFetchingMessages(false);
      })
      .catch((error) => {
        setFetchingMessages(false);
      });
  };

  const checkInitialMessages = (uid) => {
    fetchMessages(uid, true);
  };

  const checkMessages = (uid) => {
    fetchMessages(uid, false);
  };


  const fetchData = () => {
    let contacts = []
    let chats = {}

    axiosVeteriner
      .get("Veterinaries/GetVeterinarians")
      .then((response) => {
        const vets = response.data.Result;
        vets.forEach(vet => {
          contacts.push({
            uid: vet.id,
            displayName: vet.name + " " + vet.surname,
            about:
              "",
            photoURL: vet.profileImagePath,
            status: ""
          })
        });
      })
      .then(() => {
        axiosChat
          .get("/chat/myRooms")
          .then((response) => {
            response.data.forEach((room, index) => {

              let targetUser = room.users.find(usr => usr.userId !== userId);
              let meUser = room.users.find(usr => usr.userId == userId);

              let messages = room.messages.map(msg => ({
                id: msg.id,
                textContent: msg.message,
                time: new Date(msg.date).toString(),
                isSent: msg.userId === userId,
                isSeen: false // TODO
              }));
              chats[targetUser.userId] = {
                isPinned: false,
                roomId: room.id,
                initialMessagesFetched: false,
                messagesFinished: false,
                // Just For ME
                lastRead: meUser.lastRead,
                msg: [...messages]
              }
            })
          })
          .then(() => {
            const chatsContactsArray = contacts.filter(contact => {
              if (chats[contact.uid]) return chats[contact.uid]
              else return null
            })
            setChats(chats);
            setContacts(contacts);
            setChatContacts(chatsContactsArray)
            if (initialChatCheck == false) {
              setTimeout(() => {
                setInitialChatCheck(true)
              }, 100);
            }
          })
      })
      .catch((error) => { });
  }


  useEffect(() => {
    if (userId != null) {
      fetchData()
    }
  }, [userId])

  useEffect(() => {
    if (socket == null && localStorage.natusToken) {
      connectToServer();
      axiosVeteriner
        .get("Veterinary/GetLoginVeterinarianUserInfo")
        .then((response) => {
          setUserId(response.data.Result.id)
          return (response.data.Result.id)
        })
        .catch((error) => { });
      return
    }
  }, [socket]);

  useEffect(() => {
    if (socket == null) {
      return
    }
    socket.onopen = (e) => {
      console.log('Connected to chat socket server successfully');
    }

    socket.onclose = (e) => {
      console.log('Socket connection closed.');
    }

    socket.onerror = (e) => {
      console.log('Socket connection error.');
    }

    socket.onmessage = (e) => {
      const json = JSON.parse(e.data);
      const data = json.data;
      switch (json.event) {
        case 'message':
          let newMsg = {
            id: data.id,
            textContent: data.message,
            isSent: data.userId === userId,
            isSeen: false,
            time: new Date(data.date).toString()
          }

          let sendMsg,
            newChatContacts,
            oldChatContactsId = chatsContacts.map(j => j.uid);

          const [_uid, ch] = Object.entries(chats).find(([uid, value]) => value.roomId == data.roomId);
          let uid = parseInt(_uid)

          if (chats[uid]) {
            let oldState = chats[uid].msg
            oldState.push(newMsg)
            // sendMsg = [...oldState, newMsg]
            sendMsg = { ...chats };
            sendMsg[uid].msg = oldState;
          } else {
            sendMsg = {
              ...chats,
              [uid]: {
                isPinned: false,
                msg: [newMsg]
              }
            }
          }
          if (!oldChatContactsId.includes(uid)) {
            let extractContactInfo = contacts.find(k => k.uid === uid)
            newChatContacts = chatsContacts.concat(extractContactInfo)
          } else {
            newChatContacts = chatsContacts
          }
          setChats(sendMsg)
          setChatContacts(newChatContacts)
          break;

        case 'newRoom':
          let targetUser = data.users.find(usr => usr.userId !== userId);
          let _chats = { ...chats }
          _chats[targetUser.userId] = {
            isPinned: false,
            roomId: data.id,
            initialMessagesFetched: true,
            messagesFinished: false,
            msg: []
          }

          const chatsContactsArray = contacts.filter(contact => {
            if (_chats[contact.uid]) return _chats[contact.uid]
            else return null
          })
          setChats(_chats);
          setChatContacts(chatsContactsArray)
          break;

        case 'lastReadUpdate':

          break;
      }
    }
  }, [socket, chats, chatsContacts])


  return (
    <ChatSocketContext.Provider value={{
      socket,
      connectToServer,
      disConnect,
      fetchData,
      chatsContacts,
      chats,
      contacts,
      filteredChats,
      filteredContacts,
      markSeenAllMessages,
      sendMessage,
      userId, setUserId,
      searchContacts,
      checkInitialMessages,
      checkMessages,
      scrollRef,
      initialChatCheck
    }}>
      {children}
    </ChatSocketContext.Provider>
  );
};

export { ChatSocketContext, ChatSocketContextProvider };